var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 28.6204C25.6667 28.6204 28.6204 25.6667 28.6204 22C28.6204 18.3333 25.6667 15.3796 22 15.3796C18.3333 15.3796 15.3796 18.3333 15.3796 22C15.4815 25.6667 18.4352 28.6204 22 28.6204Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 0C19.6574 0 17.5185 0.305556 15.3796 1.01852V13.2407C17.213 11.8148 19.5556 11 22 11C28.1111 11 33 15.9907 33 22C33 28.1111 28.1111 33 22 33C15.8889 33 11 28.1111 11 22V2.9537C4.48148 6.72222 0 13.8519 0 22C0 34.2222 9.87963 44 22 44C34.2222 44 44 34.1204 44 22C44.1018 9.87963 34.2222 0 22 0Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeats);
export default __webpack_public_path__ + "static/media/Beats.1c252d66cc74c778b6a963b14198c3ee.svg";
export { ForwardRef as ReactComponent };